<template>
	<AppLayout
		:title="group.title"
		:subtitle="group.years"
		:return-url="route('association.representatives.index')"
		:return-label="trans('admin.users.representatives.title')"
	>
		<Empty v-if="representatives.length === 0"/>
		<CardGrid v-else>
			<Card
				v-for="representative in representatives"
				:key="`representative-${representative.id}`"
				:title="representative.user.full_name"
				:subtitle="`${representative.college.name} (${representative.college.acronym})`"
			/>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import Empty from '@/Components/UI/Empty.vue'
import {ref, type Ref, defineProps} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type Representative} from '@/Types/Association/Representatives/Representative'
import {type BoardRepresentativeGroup} from '@/Types/Association/Representatives/BoardRepresentativeGroup'

const props = defineProps<{
	group:BoardRepresentativeGroup,
	representatives:Array<Representative>,
}>()

const group:Ref<BoardRepresentativeGroup> = ref(props.group)
const representatives:Ref<Array<Representative>> = ref(props.representatives)
</script>